import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { submitPartialForm } from "../../Helpers/API/formsAPI";

function CantEngageRemarks({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    engagement_remarks: false,
  });

  // Can't Engage Remarks options
  const CANT_ENGAGE_OPTIONS = [
    "Permanently closed",
    "Temporarily closed", 
    "Under renovation",
    "Mall pullout",
    "Revisit - authorized person not available",
    "Revisit - get schedule or appointment",
    "Unlocated",
    "Duplicate",
    "Closed during visit",
    // "Refused"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      engagement_remarks: !primaryDetails.engagement_remarks,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select a remark", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.engagement_remarks;
  };
  const handleNext = () => {
    if (validateForm()) {
      const revisitOptions = [
        "Revisit - authorized person not available",
        "Revisit - get schedule or appointment",
      ];
      if (revisitOptions.includes(primaryDetails.engagement_remarks)) {
        navigation.go("revisit-details");
      } else {
        navigation.go("remarks");
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div style={{
      background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      minHeight: "100vh",
      padding: "2rem 0"
    }}>
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">CAN'T ENGAGE REMARKS</h4>
                <p className="form-desc">Please select the reason why you can't engage</p>
              </div>
               <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Can't Engage Remarks Question */}
                  <Form.Group className="mb-5" controlId="engagement_remarks">
                    <Form.Label className="form-label">
                      Can't Engage Remarks <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {CANT_ENGAGE_OPTIONS.map((option, index) => (
                        <div
                          key={`cant-engage-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.engagement_remarks === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
  
                            <Form.Check
                              type="radio"
                              name="engagement_remarks"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.engagement_remarks === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>

                    {isError.engagement_remarks && (
                      <div className="form-error">
                        Please select a remark
                      </div>
                    )}
                  </Form.Group>
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CantEngageRemarks;
